import axiosInstance from '@/utils/axiosInstance';

export async function FetchEmployeeAttendanceData(payload) {
    const response = await axiosInstance.get(`/attendance/dashboard`)
    return response.data
}

export async function getEmployeeCalendarData(year, month, employeeId) {
    const { data } = await axiosInstance.get(`/attendance/Calendar`, {
        params: employeeId ? { year, month, employeeId } : { year, month }
    });
    return data;
}

export async function updateEmployeeAttendance(data) {
    const response = await axiosInstance.post(`/attendance/mark`, data)
    return response.data
}

export async function getAttendanceOverview() {
    const response = await axiosInstance.get('/attendance/dashboard/attendance-overview');
    return response
}
export async function fetchAttendanceTrend(rangekey) {
    const { data } = await axiosInstance.get(`/attendance/trend`, {
        params: { rangekey }
    });
    return data;
}

export async function addLateArrival(data) {
    const { reponse } = await axiosInstance.post(`/attendance/late-arrivals`, { data });
    return Array.isArray(reponse) ? reponse : reponse?.data ?? [];
}

export async function createRegularizationRequests(formData) {
    const { reponse } = await axiosInstance.post(`/attendance/regularization-requests`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
    });
    return reponse;
}

export async function getRegularizationRequests() {
    const { data } = await axiosInstance.get(`/attendance/regularization-requests`);
    return Array.isArray(data) ? data : data?.data ?? [];
}

export async function updateRegularizationRequests(data) {
    const { reponse } = await axiosInstance.put(`/attendance/regularization-requests`, { data });
    return Array.isArray(reponse) ? reponse : reponse?.data ?? [];
}

// --- ATTENDANCE: Policy applicable to the logged-in employee (Help Center) ---
export async function fetchEmployeeAttendancePolicy(employeeId) {
    const { data } = await axiosInstance.get(`/attendance/attendance-policy`, {
        params: employeeId ? { employeeId } : undefined,
    });
    return data;
}

// --- ATTENDANCE: Colleagues from the employee's own department on approved
// leave for a given day (Team Availability). `date` is "yyyy-MM-dd"; omit it to
// get the company's today.
export async function fetchDepartmentLeaves(date) {
    const { data } = await axiosInstance.get(`/attendance/department-leaves`, {
        params: date ? { date } : undefined,
    });
    return data?.data ?? data;
}

export async function getShift() {
    const { data } = await axiosInstance.get(`/attendance/shifts`);
    return Array.isArray(data) ? data : data?.data ?? [];
}

export async function upsertShift(payload) {
    const { data } = await axiosInstance.post(`/attendance/shifts`, payload);
    return data;
}

export async function deleteShift(shiftId) {
    const { data } = await axiosInstance.delete(`/attendance/shifts/${shiftId}`,);
    return Array.isArray(data) ? data : data?.data ?? [];
}


export async function getOTLogs() {
    const { data } = await axiosInstance.get(`/attendance/ot-request`);
    return Array.isArray(data) ? data : data?.data ?? [];
}

export async function upsertOTLogs(payload) {
    const { data } = await axiosInstance.post(`/attendance/ot-request`, payload);
    return Array.isArray(data) ? data : data?.data ?? [];
}

export async function getEmployeeShiftSchedules({
    page,
    limit,
    search,
}) {
    const { data } = await axiosInstance.get(`/attendance/shift-schedules`, {
        params: { page, limit, search },
    });

    return data;
}

export async function upsertEmployeeShiftSchedule(payload) {
    const { data } = await axiosInstance.post(`/attendance/shift-schedule/upsert`, { payload });
    return Array.isArray(data) ? data : data?.data ?? [];
}

export async function updateOvertimeStatus(data) {
    const { reponse } = await axiosInstance.post(`/attendance/ot-request`, { data });
    return Array.isArray(reponse) ? reponse : reponse?.data ?? [];
}

export async function fetchMusterRollData() {
    const reponse = await axiosInstance.get(`/attendance/muster-roll`);
    return reponse;
}

export async function exportMusterRollData(year, month) {
    const response = await axiosInstance.get(
        `/attendance/muster-roll/export`,
        {
            params: {
                year,
                month,
            },
            responseType: "arraybuffer",
            withCredentials: true,
        }
    );

    return response;
}

export async function exportMusterPDF(year, month) {
    const response = await axiosInstance.get(
        `/attendance/muster-roll/export-pdf`,
        {
            params: {
                year,
                month,
            },
        }
    );
    return response;
}

export async function createOTLog(payload) {
    const { data } = await axiosInstance.post(`/attendance/ot`, payload);
    return Array.isArray(data) ? data : data?.data ?? [];
}

export async function getEmployeeDashboardCalendarData(year, month) {
    const { data } = await axiosInstance.get(`/attendance/employee-dashboard`, {
        params: { year, month }
    });
    return data;
}

//monthly summary
export async function getMonthSummaryData(year, month) {
    const { data } = await axiosInstance.get(`/attendance/summary-month`, {
        params: { year, month }
    });
    return data;
}

//monthly late
export async function getMonthLateData(year, month) {
    const { data } = await axiosInstance.get(`/attendance/late-month`, {
        params: { year, month }
    });
    return data;
}

//monthly over-time
export async function getMonthOvertimeData(year, month) {
    const { data } = await axiosInstance.get(`/attendance/ot-month`, {
        params: { year, month }
    });
    return data;
}

//monthly muster
export async function getMonthMusterData(year, month) {
    const { data } = await axiosInstance.get(`/attendance/muster-month`, {
        params: { year, month }
    });
    return data;
}